import type { JSX, ReactNode } from 'react';

type Padding = 'none' | 'sm' | 'md' | 'lg';

const PADDING: Record<Padding, string> = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export function Card({
  children,
  padding = 'md',
  className = '',
  as: Tag = 'section',
  interactive = false,
}: {
  children: ReactNode;
  padding?: Padding;
  className?: string;
  as?: 'section' | 'article' | 'div' | 'aside';
  interactive?: boolean;
}): JSX.Element {
  const base =
    'rounded-3xl border border-slate-200 bg-white/90 shadow-sm backdrop-blur-sm dark:border-slate-800 dark:bg-slate-900/80';
  const hover = interactive
    ? 'transition hover:-translate-y-0.5 hover:shadow-lg hover:border-slate-300 dark:hover:border-slate-700'
    : '';
  return (
    <Tag className={`${base} ${PADDING[padding]} ${hover} ${className}`.trim()}>{children}</Tag>
  );
}

export function CardHeader({
  title,
  subtitle,
  actions,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}): JSX.Element {
  return (
    <div className="mb-4 flex items-start justify-between gap-4">
      <div>
        <h3 className="text-base font-semibold tracking-tight">{title}</h3>
        {subtitle ? (
          <p className="mt-0.5 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  );
}
